import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { patientsApi } from '../api/patientsApi';

export function usePatientCommunications(
  id: number | null | undefined,
  filters?: { lane?: string; channel?: string; page?: number },
) {
  return useQuery({
    queryKey: keys.patient.comms(id ?? 0, filters),
    queryFn: ({ signal }) => patientsApi.getCommunications(id!, filters, { signal }),
    enabled: id != null,
    staleTime: 60_000,
  });
}
